import { mapActions, mapMutations, mapGetters } from "vuex";
import {
  resetUserPassword,
  UpdateCustomer,
  CreateSoUser,
  signInWithPassword,
  storeCheckoutCard,
  UpdateCustomerPhone,
  isUserPhoneVerified,
} from "./../../../src/api/services/userService";
import * as userService from "../../api/services/userService";
import firebase from "firebase/compat/app";
import { logger } from "../../api/Logger";
import { auth } from "../../server";
export default {
  async mounted(isDesktop, registerObj) {
    registerObj.checkGoogleLoaded();
  },
  methods: {
    ...mapActions([
      "signUserIn",
      "signUserUp",
      "signUserInFacebook",
      "signUserInGoogle",
      "signUserInPhone",
      "setSkipAuthentication",
      "logout",
    ]),
    ...mapMutations(["setStoreLoaded", "setUser", "setStore"]),
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.storeid },
      });
    },
    getMax() {
      let country = this.currentStoreDoc
        ? this.currentStoreDoc.Location.Country
        : null;
      return country == "AU" ? 10 : 15;
    },
    getRegex() {
      let country = this.currentStoreDoc
        ? this.currentStoreDoc.Location.Country
        : null;
      return country == "AU" ? /04\d{8}/ : /\d/;
    },
    signOut() {
      this.logout();
      this.goBack();
    },
    loadRecoveryPasswordForm(base64User) {
      let that = this;
      const decodedUserDocFromUrl = JSON.parse(
        new Buffer(base64User, "base64").toString("ascii")
      );
      signInWithPassword(
        decodedUserDocFromUrl.Email,
        decodedUserDocFromUrl.ResetPasswordToken
      )
        .then(() => {
          that.UserDoc = decodedUserDocFromUrl;
          that.IsNewUser = that.UserDoc.IsNewUser;
          that.setStoreLoaded();
          that.setStore(that.storeid);
        })
        .catch(() => {
          that.recoveryLinkExpired = true;
          window.setTimeout(function () {
            that.signOut();
          }, 4000);
        });
    },
    async resetPassword() {
      let that = this;
      if (that.loading) return;
      await this.$validator.validateAll();
      that.loading = true;
      that.UserDoc.Company_ID = this.storeid;
      await resetUserPassword(that.UserDoc);
      that.registrationResponse = {
        status: 200,
        msg: "Registration completed successfully.",
      };
      if (that.UserDoc.Card) {
        try {
          await storeCheckoutCard(
            auth.currentUser.uid,
            that.UserDoc.Card,
            that.UserDoc.Company_ID
          );
          await UpdateCustomerPhone(
            {
              HQCompanyID: that.UserDoc.Company_ID,
              id: auth.currentUser.uid,
            },
            that.UserDoc.Phone
          );
        } catch (error) {
          logger.logObject(error);
        }
      }
      that.loading = false;
      window.setTimeout(async () => {
        await that.signUserIn({
          email: that.UserDoc.Email,
          password: that.UserDoc.Password,
        });
        if (!that.storeid) that.$router.push("/");
        else {
          that.$router.push(`../../../../store/${that.storeid}`);
        }
      }, 2000);
    },

    checkGoogleLoaded() {
      var that = this;
      var interval = setInterval(() => {
        try {
          if (google && google.maps) {
            that.googleLoaded = true;
            clearInterval(interval);
          }
        } catch {
          that.googleLoaded = false;
        }
      }, 500);
    },
    isValidDate(s) {
      if (s && s != "") {
        var bits = s.split("/");
        var d = new Date(bits[2], bits[1] - 1, bits[0]);
        var valid =
          d.getFullYear() == bits[2] &&
          d.getMonth() + 1 == bits[1] &&
          bits[2].length == 4;
        if (valid) {
          this.birthDatestatus = 0;
          return true;
        } else {
          this.birthDatestatus = 2;
          return false;
        }
      } else {
        this.birthDatestatus = 1;
        return false;
      }
    },
    async register() {
      // var birthdatestate =
      //   this.isRolldStore() || this.isValidDate(this.birthDate);
      // this.$validator.validateAll().then((valid) => {
      //   if (!valid) return;
      //   if (!birthdatestate) return;
      //   var dates = this.birthDate.split("/");
      this.loading = true;
      let that = this;
      try {
        const mobile = this.formatMobile(
          that.mobile || that.phoneNumber,
          that.countryCode
        );

        // for single page registration, check if mobile exists first
        if (that.fullScreen) {
          let res = await userService.userExistsWithPhoneNumber(mobile);
          if (res) {
            that.error =
              "This Mobile Number is already registered. Please login or use a different mobile number";
            return;
          }
        }

        const res = await this.signUserUp({
          email: that.email,
          password: that.password,
        });
        if (!res) {
          that.error = "Failed to register. Please try again";
          return;
        }
        const response = await UpdateCustomer(res.user.uid, {
          Email: that.email,
          PhoneNumber: mobile,
          Address: that.address,
          BirthDate: that.birthDate,
          FirstName: that.firstName,
          LastName: that.lastName,
          State: that.state,
          Postcode: that.postCode,
          HQCompanyID: that.currentStoreDoc
            ? that.currentStoreDoc.HQCompanyID || that.currentStoreDoc.ID
            : null,
        });

        if (!response || !response.data || !response.data.Success) {
          that.error = "Failed to register. Please try again";
          return;
        }

        const userModel = {
          id: res.user.id,
          email: that.email,
          login: false,
          HQCompanyID: that.currentStoreDoc
            ? that.currentStoreDoc.HQCompanyID || that.currentStoreDoc.ID
            : null,
        };

        if (this.isRolldStore()) {
          this.$emit("show-verification", userModel);
          return;
        }

        // if field is not explicitly set to false, display mobile authentication
        const enableMobileAuthentication =
          this.viewConfig.EnableMobileAuthentication !== false;
        if (that.fullScreen) {
          if (enableMobileAuthentication) {
            let isNumberVerified = await isUserPhoneVerified();
            if (!isNumberVerified) {
              await userService.UpdateCustomerPhone(userModel, mobile);
              await userService.sendSmsVerification();
              that.multiStepIndex = 3;
              this.smsTimer = setInterval(() => {
                if (this.resendWait > 0) this.resendWait--;
              }, 1000);
              return;
            }
          }

          await that.$router.push("/store/" + this.$route.params.storename);
          return;
        }
        this.$emit("close-overlay");
      } catch (error) {
        that.error = error.message;
      } finally {
        that.loading = false;
      }
    },

    setAddress() {
      var that = this;
      that.address = that.$refs.gAutoComplete.$el.value;
      if (that.address) {
        this.$refs.gAutoComplete.update(that.address);
      }
    },

    async verifyOtpAndRegisterSoUser(verificationCode) {
      let that = this;
      that.verificationCode = verificationCode;
      const birthdatestate = this.isValidDate(this.birthDate);
      this.$validator.validateAll().then(async (valid) => {
        if (!valid) return;
        let date = null;
        const dates = this.birthDate.split("/");
        if (birthdatestate) {
          date = new Date(
            Number(dates[2]),
            Number(dates[1]) - 1,
            Number(dates[0])
          );
        }
        that.loading = true;

        if (!verificationCode || verificationCode.length !== 6) {
          that.showError("Invalid OTP Format !");
          return;
        }

        try {
          const verificationId = that.verificationId;
          const credential = await firebase.auth.PhoneAuthProvider.credential(
            verificationId,
            verificationCode
          );

          const res = await auth.signInWithCredential(credential);

          const userID = res.user.uid;
          that.step = 1;
          that.loading = true;
          const formattedMobile = this.formatMobile(
            that.mobile,
            that.countryCode
          );
          const HQCompanyID = that.currentStoreDoc
            ? that.currentStoreDoc.HQCompanyID || that.currentStoreDoc.ID
            : null;

          const response = await CreateSoUser({
            userID,
            Email: that.email,
            Mobile: formattedMobile,
            Gender: that.gender ? that.gender.id : null,
            Postcode: that.postcode,
            BirthDate: date,
            FirstName: that.firstName,
            LastName: that.lastName,
            HQCompanyID,
            PreferredStore: that.preferredStore ? that.preferredStore.ID : null,
          });
          if (!response || !response.data || !response.data.Success) {
            that.success = false;
            that.showError("Failed to register. Please try again");
            return;
          }

          that.email = "";
          that.mobile = "";
          that.address = "";
          that.birthDate = "";
          that.firstName = "";
          that.lastName = "";
          that.password = "";
          that.confirmPassword = "";
          that.$validator.reset();
          that.success = true;
          await this.$router.push({
            name: "finalizeSoRegisteration",
            params: {
              storeid: this.storeid,
              userId: response.data.Customer.CustomerMemberCode,
              storename: this.currentStoreDoc.Name,
            },
          });
        } catch (error) {
          that.success = false;
          switch (error.code) {
            case "auth/invalid-phone-number":
              that.error = "Invalid Phone Number Format !";
              break;

            case "auth/invalid-verification-code":
              that.showError("Invalid OTP Entered !");
              break;

            default:
              that.showError(
                error.message || "Registration failed. Please try again."
              );
          }
        } finally {
          that.loading = false;
        }
      });
    },

    // send OTP reusable function
    async sendUserOtp(phoneNumber) {
      try {
        const that = this;
        const appVerifier = that.appVerifier;
        const phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
        const verificationId = await phoneAuthProvider.verifyPhoneNumber(
          phoneNumber,
          appVerifier
        );
        that.verificationId = verificationId;
      } catch (e) {
        throw e;
      }
    },

    // login non branded store user
    async sendOtpNonBrandedStoreUser() {
      const that = this;
      try {
        that.smsTimer = setInterval(() => {
          if (that.resendWait > 0) that.resendWait--;
        }, 1000);
        that.error = "";
        that.loading = true;
        const mobile = this.formatMobile(that.mobile);
        if (!mobile) {
          that.error = "Invalid Phone Number Format !";
          return;
        }

        const phoneNumber = that.countryCode + mobile;
        if (!phoneNumber || !phoneNumber.length) {
          that.error = "Please enter a valid mobile number";
          return;
        }

        // if mobile does not exist in db as user to signup
        let mobileExists;
        try {
          mobileExists = await userService.userExistsWithPhoneNumber(
            phoneNumber
          );
        } catch (e) {
          that.error = e.message;
          that.loading = false;
          return;
        }
        if (!mobileExists) {
          this.step = 1;
          this.loading = false;
          this.error =
            "User does not exist with this mobile number. Please signup first.";
          return;
        }

        await this.sendUserOtp(phoneNumber);
        that.step = that.step === 1 ? 2 : 1;
      } catch (error) {
        switch (error.code) {
          case "auth/invalid-phone-number":
            that.error = "Invalid Phone Number Format !";
            break;

          default:
            that.error = error.message;
        }
      } finally {
        that.loading = false;
      }
    },

    // veriy non branded store user OTP
    async verifyNonBrandedOtp(value) {
      const that = this;
      try {
        that.error = "";
        that.loading = true;
        if (value.length != 6) {
          this.error = "Invalid OTP Format !";
          return;
        }
        const code = value;

        await this.signUserInPhone({
          verificationCode: code,
          verificationId: that.verificationId,
        });

        that.$emit("close-overlay");
      } catch (error) {
        // check invalid code
        if (error.code === "auth/invalid-verification-code") {
          that.error = "Invalid OTP Entered !";
          return;
        }
        that.error = error.message || "An Error Occurred During Authentication";
      } finally {
        that.loading = false;
      }
    },

    // register non branded store user
    async sendOtp() {
      const that = this;
      try {
        that.error = "";
        that.loading = true;
        const mobile = this.formatMobile(that.mobile);
        if (!mobile) {
          that.error = "Invalid Phone Number Format !";
          return;
        }

        const phoneNumber = that.countryCode + mobile;

        if (this.isBranded()) {
          const emailExists = await userService.userExistsWithEmail(that.email);
          if (emailExists) {
            this.step = 1;
            this.loading = false;
            this.error = "User already exists with this email";
            return;
          }
        }
        const mobileExists = await userService.userExistsWithPhoneNumber(
          phoneNumber
        );
        if (mobileExists) {
          this.step = 1;
          this.loading = false;
          this.error = "User already exists with this mobile number";
          return;
        }

        await this.sendUserOtp(phoneNumber);
        that.step = that.step === 1 ? 2 : 1;
      } catch (error) {
        if (error.code === "auth/invalid-phone-number") {
          that.error = "Invalid Phone Number Format !";
          return;
        }

        that.error = error.message;
      } finally {
        that.loading = false;
      }
    },

    // register non branded store user
    async sendLoyaltyOtp() {
      const that = this;
      try {
        that.error = "";
        that.loading = true;
        const mobile = this.formatMobile(that.mobile);
        if (!mobile) {
          that.error = "Invalid Phone Number Format !";
          return;
        }

        const phoneNumber = that.countryCode + mobile;

        await this.sendUserOtp(phoneNumber);

        that.smsTimer = setInterval(() => {
          if (that.resendWait > 0) that.resendWait--;
        }, 1000);

        that.step = that.step === 1 ? 2 : 1;
      } catch (error) {
        if (error.code === "auth/invalid-phone-number") {
          that.error = "Invalid Phone Number Format !";
          return;
        }

        that.error = error.message;
      } finally {
        that.loading = false;
      }
    },

    // remove initial 0
    formatMobile(mobileStr, countryCode) {
      try {
        let mobile = mobileStr.replace(/\s/g, "");
        if (!mobile || !mobile.length) {
          return null;
        }

        if (mobile.startsWith("0")) {
          mobile = mobile.substring(1);
        }

        if (countryCode && countryCode.length) {
          if (mobile.startsWith(countryCode)) {
            return mobile;
          }

          return countryCode + mobile;
        }
        return mobile;
      } catch (e) {
        console.log({ e });
        return null;
      }
    },

    // register branded store user
    async verifyOtp(value) {
      const that = this;
      try {
        that.error = "";
        that.loading = true;
        if (value.length != 6) {
          this.error = "Invalid OTP Format !";
          return;
        }
        const code = value;
        const mobile = this.formatMobile(that.mobile);
        if (!mobile) {
          that.error = "Invalid Phone Number Format !";
          return;
        }
        const phoneNumber = that.countryCode + mobile;

        const newUser = {
          Email: that.email,
          PhoneNumber: phoneNumber,
          Mobile: phoneNumber,
          Address: that.address,
          BirthDate: that.birthDate,
          FirstName: that.firstName,
          LastName: that.lastName,
          State: that.state,
          Postcode: that.postCode,
          HQCompanyID: that.currentStoreDoc
            ? that.currentStoreDoc.HQCompanyID || that.currentStoreDoc.ID
            : null,
        };

        await this.signUserInPhone({
          verificationCode: code,
          verificationId: that.verificationId,
          userInfo: newUser,
        });

        if (that.fullScreen) {
          await that.$router.push("/store/" + this.$route.params.storename);
        }

        that.$emit("close-overlay");
      } catch (error) {
        // check invalid code
        if (error.code === "auth/invalid-verification-code") {
          that.error = "Invalid OTP Entered !";
          return;
        }
        that.error = error.message || "An Error Occurred During Registration";
      } finally {
        that.loading = false;
      }
    },

    async resendSms() {
      const that = this;
      this.loading = true;
      const mobile = this.formatMobile(that.mobile);
      if (!mobile) {
        that.error = "Invalid Phone Number Format !";
        return;
      }
      const phoneNumber = that.countryCode + mobile;
      const appVerifier = that.appVerifier;
      const phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
      const verificationId = await phoneAuthProvider.verifyPhoneNumber(
        phoneNumber,
        appVerifier
      );
      that.verificationId = verificationId;
      this.resendWait = 30;
      this.loading = false;
    },

    initReCaptcha() {
      if (
        document.getElementById("recaptcha-container") &&
        !window.recaptchaVerifier
      ) {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
          }
        );
      }
      this.appVerifier = window.recaptchaVerifier;
    },

    skipAuthAndCheckout() {
      this.setSkipAuthentication(true);
      this.$emit("close-overlay");
    },
    facebookLogin() {
      let that = this;
      this.signUserInFacebook()
        .then(() => {
          if (!that.isMobile()){
            if(that.fullScreen){
              that.$router.push("/store/" + that.$route.params.storename );
              return
            }
            that.$emit("close-overlay");
          }
          else {
            if (!that.storeid) that.$router.push("/");
            else {
              if (that.forgift && that.forgift === true)
                that.$router.push(
                  `../../store/${that.storeid}/checkout/giftcards`
                );
              else that.$router.push(`../../store/${that.storeid}/checkout`);
            }
          }
        })
        .catch((error) => {
          that.error = error.message;
        });
    },
    googleLogin() {
      let that = this;
      that.loading = true;
      this.signUserInGoogle()
        .then(async (res) => {
          //check mobile verification
          let isNumberVerified = await isUserPhoneVerified();
          that.loading = false;

          const enableMobileAuthentication = that.viewConfig.EnableMobileAuthentication !== false;
          if (!isNumberVerified && enableMobileAuthentication) {

            that.$emit("need-verification", {
              id: res.user.uid,
              email: res.user.email,
              login: true,
              HQCompanyID:
                that.currentStoreDoc.HQCompanyID || that.currentStoreDoc.ID,
            });
          } else {
            if(that.fullScreen){
              await that.$router.push("/store/" + that.$route.params.storename + "/login");
              return
            }
            that.$emit("close-overlay");
          }
        })
        .catch((error) => {
          that.error = error.message;
          that.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters(["user", "viewConfig"]),
  },
};
